module.exports = __webpack_public_path__ + "fonts/overpass-semibold.2099f05c.otf";